import React from "react";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";

import WiremapDiagram from "./diagram";
import WiremapTable from "./table";
import WiremapGenerator from "../../../../../common/wiremapGenerator";

class WiremapResult extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      classes,
      translate,
      subtestResultsWiremap,
      showMargin,
      subtest,
      wiremapStandard,
      chartMeasurementUnit,
      thumbnailView,
      results
    } = this.props;

    if (subtestResultsWiremap) {
      chartMeasurementUnit &&
        WiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
      translate && WiremapGenerator.setTranslate(translate);

      if (thumbnailView) {
        if (
          results &&
          results.data &&
          results.data.testedcabletype.toLowerCase() == "coaxialcable"
        ) {
          let coaxData = {
            ...subtestResultsWiremap,
            Details: subtestResultsWiremap.Details.filter(
              item => item.DHPin == "4" || item.DHPin == "5"
            )
          };
          return (
            <WiremapDiagram
              data={coaxData}
              wiremapStandard={wiremapStandard}
              translate={translate}
              thumbnailView
              results={results}
            />
          );
        } else {
          return (
            <WiremapDiagram
              data={subtestResultsWiremap}
              wiremapStandard={wiremapStandard}
              translate={translate}
              thumbnailView
              results={results}
            />
          );
        }
      } else {
        let coaxData;
        if (
          results &&
          results.data &&
          results.data.testedcabletype.toLowerCase() == "coaxialcable"
        ) {
          coaxData = {
            ...subtestResultsWiremap,
            Details: subtestResultsWiremap.Details.filter(
              item => item.DHPin == "4" || item.DHPin == "5"
            )
          };
        }
        return (
          <Paper className={classes.paper}>
            <Grid container>
              <Grid item sm={12} md={6}>
                <WiremapTable
                  data={
                    results &&
                    results.data &&
                    results.data.testedcabletype.toLowerCase() ==
                      "coaxialcable" &&
                    coaxData
                      ? coaxData
                      : subtestResultsWiremap
                  }
                  translate={translate}
                  chartMeasurementUnit={chartMeasurementUnit}
                  isCoax={
                    results &&
                    results.data &&
                    results.data.testedcabletype.toLowerCase() == "coaxialcable"
                  }
                  hideLength={false}
                  isMobileTest={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <WiremapDiagram
                  data={
                    results &&
                    results.data &&
                    results.data.testedcabletype.toLowerCase() == "coaxialcable"
                      ? coaxData
                      : subtestResultsWiremap
                  }
                  wiremapStandard={wiremapStandard}
                  translate={translate}
                  results={results}
                />
                <Typography variant="caption" gutterBottom align="center">
                  {translate("wiremap_length")}:
                  {WiremapGenerator.convertMeasurementUnit(
                    subtestResultsWiremap.RefLength,
                    translate
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        );
      }
    } else {
      return <div></div>;
    }
  }
  componentWillMount() {
    const { getSubtestResults, subtest, pager } = this.props;

    getSubtestResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getSubtestResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getSubtestResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(WiremapResult);
